import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
var log = logFactory('splitio-engine:matcher');
import thenable from '../../utils/promise/thenable';
function matcherSegmentContext(segmentName, storage) {
  function segmentMatcher(key) {
    var isInSegment = storage.segments.isInSegment(segmentName, key);
    if (thenable(isInSegment)) {
      isInSegment.then(function (result) {
        var _context, _context2;
        log.debug(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "[asyncSegmentMatcher] evaluated ".concat(segmentName, " / ")).call(_context2, key, " => ")).call(_context, isInSegment));
        return result;
      });
    } else {
      var _context3, _context4;
      log.debug(_concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "[segmentMatcher] evaluated ".concat(segmentName, " / ")).call(_context4, key, " => ")).call(_context3, isInSegment));
    }
    return isInSegment;
  }
  return segmentMatcher;
}
export default matcherSegmentContext;